import { apiInstance, handleApiError } from "./InstanceApi";

export const getAgentService = async (uID) => {
    try {
        const response = await apiInstance.get('agent/', {
            params: { uID }
        });
        return response.data;
    } catch (error) {
        return handleApiError(error);
    }
};

export const UpdateAgent = async (data) => {
    try {
        const response = await apiInstance.put('agent', data);
        return response.data
    } catch (error) {
        return handleApiError(error)
    }
}
